import {TranslationObject} from '@colonist/i18n'
import {ViewPopup} from '../../../shared/scripts/ui_popup/ViewPopup'
import {StorageWrapper} from '../../../shared/scripts/StorageWrapper'

export class UIMDeviceInfoPopup extends ViewPopup {
    constructor() {
        const title: TranslationObject = {key: 'strings:colonistCommon.utils.#buffer', options: {value: `Debug Device Info`}}

        const dimensions = `<b>Dimensions: </b> ${document?.body?.clientWidth} x ${document?.body?.clientHeight} <br/>`
        const userAgent = `<b>UA: </b> ${navigator?.userAgent}  <br/>`
        const buildNumber = `<b>Build Number: </b> ${StorageWrapper.getBuildNumber()}  <br/>`
        const gameOrientation = `<b>PortraitMode: </b> ${StorageWrapper.isPortraitGamePlayEnabled()}  <br/>`
        const platform = `<b>Platform: </b> ${StorageWrapper.getPlatform()}  <br/>`
        const statusBarHeight = `<b>StatusBarHeight: </b> ${StorageWrapper.getStatusBarHeight()} <br/>`
        const bottomArea = `<b>SafeAreaInsetBottom: </b> ${StorageWrapper.getSafeAreaInsetBottom()} <br/>`

        const bodyText = dimensions + userAgent + buildNumber + gameOrientation + platform + statusBarHeight + bottomArea
        const body: TranslationObject = {key: 'strings:colonistCommon.utils.#buffer', options: {value: bodyText}}

        super(title,
            body,
            () => undefined,
            () => undefined,
            true,
            {showXonHeader: true, showCheckButton: false, showXButton: false})
    }
}
